import { MeiliSearch } from 'meilisearch'

const client = new MeiliSearch({
  host: import.meta.env.PUBLIC_MEILISEARCH_HOST,
  apiKey: import.meta.env.PUBLIC_MEILISEARCH_APIKEY,
})

function extractUUIDFromURL(url: string) {
  const uuid = url.split('-').pop()
  return uuid
}

export function useMeilisearch() {
  const getItemFromIndexBySlug = async <TItem extends Record<string, any>> (indexName: string, slug: string) => {
    let item: any
    const uuid = extractUUIDFromURL(slug)

    try {
      const index = client.index(indexName)
      // try to get by uuid first
      let res = await index.search<TItem>('', {
        filter: `slug_uuid="${uuid}"`,
        limit: 1,
      })
      // no results, try to get by slug
      if (res.hits.length === 0) {
        res = await index.search<TItem>('', {
          filter: `slug="${slug}"`,
          limit: 1,
        })
      }
      // // still no results? maybe legacy ... try typo3_slug
      // if (res.hits.length === 0) {
      //   res = await index.search<TItem>('', {
      //     filter: `typo3_slug="${slug}"`,
      //     limit: 1,
      //   })
      // }

      // get the first item
      item = res.hits[0]

      if (!item) {
        throw new Error('Item not found')
      }

      return {
        data: item as TItem,
        error: null,
      }
    }
    catch (error) {
      console.error(error)
      return {
        data: null,
        error,
      }
    }
  }

  const getLatestItemsFromIndex = async <TItem extends Record<string, any>> (indexName: string, sorting: string, limit: number, filter?: string) => {
    let items: any[]
    try {
      const index = client.index(indexName)

      const res = await index.search<TItem>('', {
        filter,
        sort: sorting.length ? [sorting] : undefined,
        limit: 2000,
      })
      const total = res.hits.length
      items = res.hits.slice(0, limit)

      return {
        data: items as TItem[],
        total,
        error: null,
      }
    }
    catch (error) {
      console.error(error)
      return {
        data: null,
        total: 0,
        error,
      }
    }
  }

  const getItemFromIndexByID = async <TItem extends Record<string, any>> (indexName: string, id: number) => {
    let item: any

    try {
      const index = client.index(indexName)

      const res = await index.search<TItem>('', {
        filter: `id="${id}"`,
        limit: 1,
      })
      item = res.hits[0]

      return {
        data: item as TItem,
        error: null,
      }
    }
    catch (error) {
      console.error(error)
      return {
        data: null,
        error,
      }
    }
  }

  return {
    client,
    getItemFromIndexBySlug,
    getLatestItemsFromIndex,
    getItemFromIndexByID,
  }
}
